// extracted by mini-css-extract-plugin
export default {"counterContainer":"counter_counterContainer__Wl9p4","counterCol":"counter_counterCol__24Xgy"};